<script>
import { ordersControlsPresets } from '@/utils/constants'

import ordersTable from '@/components/orders/listOrders/views/ordersTable.vue'
import formFilters from '@/components/orders/listOrders/views/formFilters.vue'
import SearchResultsControls from '@/components/views/filters/SearchResultsControls.vue'
import PaymentMethodSelect from '@/components/orders/views/PaymentMethodSelect.vue'
import infiniteScroll from '@/components/views/infiniteScroll/infiniteScroll.vue'

export default {
  name: 'list-orders',
  components: {
    ordersTable,
    formFilters,
    SearchResultsControls,
    infiniteScroll,
    PaymentMethodSelect
  },
  metaInfo: {
    title: 'Список заказов'
  },
  data: () => ({
    ordersControlsPresets
  }),
  computed: {
    isLoading() {
      return this.$store.getters['orders/isLoading']
    },
    isLoadingError() {
      return this.$store.getters['orders/isLoadingError']
    },
    pagination() {
      return this.$store.getters['orders/getPagination']
    },
    form() {
      return this.$store.getters['orders/getForm']
    },
    isCollection() {
      return this.$store.getters['orders/getCollection'].length
    }
  },
  created() {
    this.$store.dispatch('getDictionary', {
      params: {},
      config: {
        dictionaryName: 'currencies',
        target: 'orders.dictionaries.currencies'
      }
    })

    this.$store.commit('orders/setIsLoading', true)
    this.$store.dispatch('orders/getCollection', {
      ...this.form
    })
  },
  beforeDestroy() {
    this.$store.commit('orders/setInitialState')
  },
  methods: {
    loadMore() {
      this.$store.commit('orders/setIsLoading', true)
      this.$store.dispatch('orders/getCollection', {
        ...this.form,
        page: this.pagination.page + 1
      })
    },
    search() {
      this.$store.dispatch('orders/getCollection', {
        ...this.form
      })
    }
  }
}
</script>
<template>
  <div class="list-orders">
    <div class="list-orders__header">
      <h1 class="list-orders__header-title order__header-title--topped">
        Список заказов
      </h1>
    </div>
    <div class="list-orders__container">
      <div>
        <search-results-controls
          store-module="orders"
          getter-name="getField"
          setter-name="setField"
          preset-setter="updateSearchPreset"
          target-sorting-order="form.sortDirection"
          target-sorting-field="form.sortBy"
          target-preset="activePreset"
          :presets="ordersControlsPresets"
          @sortFieldChanged="search"
          @sortOrderChanged="search"
          @presetChanged="search"
        />
        <div
          v-if="!isLoading"
          class="search-content__no-results"
        >
          <h2 v-if="!isCollection">
            Заказы не найдены<br>
            Попробуйте изменить параметры поиска и фильтров
          </h2>
          <h2 v-if="isLoadingError">
            Произошла ошибка при загрузке списка заказов
          </h2>
        </div>
        <infinite-scroll
          v-if="(isLoading || isCollection) && !isLoadingError"
          :pagination="pagination"
          :is-loading="isLoading"
          @loadMore="loadMore"
        >
          <orders-table />
        </infinite-scroll>
      </div>
      <div class="sidebar app-sidebar">
        <form-filters />
      </div>
    </div>
    <payment-method-select />
  </div>
</template>
